/**
 * Polyfill for Screen Orientation API
 * This provides a minimal implementation when the API isn't available
 */

export function applyOrientationPolyfill() {
  if (!window.screen || !window.screen.orientation) {
    // Create a minimal implementation
    window.screen = window.screen || {};
    window.screen.orientation = {
      angle: 0,
      type: 'portrait-primary',
      onchange: null,
      
      // Add stub methods
      // eslint-disable-next-line no-unused-vars
      lock: function(orientation) {
        return Promise.resolve();
      },
      unlock: function() {
        return Promise.resolve();
      },
      // eslint-disable-next-line no-unused-vars
      addEventListener: function(type, listener) {
        // No-op implementation
      },
      // eslint-disable-next-line no-unused-vars
      removeEventListener: function(type, listener) {
        // No-op implementation
      }
    };
    
    // Log a one-time message about the polyfill
    console.info('Screen Orientation API polyfill applied');
  }
}

// Apply polyfill immediately
applyOrientationPolyfill();

export default {
  install(Vue) {
    // Make it available in Vue components if needed
    Vue.prototype.$screenOrientation = window.screen.orientation;
  }
};
